// export const BASE_URL = 'http://10.10.77.3:8080';
export const BASE_URL = 'https://api.liting.uz';
export const BASE_URL_PHOTO = (BASE_URL + "/api/file/photo/");